module.exports = __webpack_public_path__ + "img/com.Electrolux.AEGRX9.1112137e.webp";